import { globalStyle, style, styleVariants } from '@vanilla-extract/css';

import { embla } from '../components/EmblaCarousel/embla.css';

export const productsGrid = style({
  position: 'relative',
  padding: 'var(--products-padding)',
  width: '100%',
  gap: 'var(--gap)',

  '@media': {
    'only screen and (--mobile)': {
      gap: 'var(--mobile-gap)',
    },
  },
});

/* Carousel overrides start here */
globalStyle(`${productsGrid} ${embla} .embla`, {
  vars: {
    '--slide-control-background-color': 'var(--products-slider-control-background-color)',
    '--slide-control-text-color': 'var(--products-slider-control-text-color)',
    '--slide-control-border-color': 'var(--products-slider-control-border-color)',
  },
  '@media': {
    '(min-width: 1024px)': {
      vars: {
        '--slide-size': 'var(--products-desktop-slide-size)',
      },
    },
    'only screen and (--mobile)': {
      vars: {
        '--slide-control-background-color':
          'var(--products-mobile-slider-control-background-color, var(--products-slider-control-background-color))',
        '--slide-control-text-color':
          'var(--products-mobile-slider-control-text-color, var(--products-slider-control-text-color))',
        '--slide-control-border-color':
          'var(--products-mobile-slider-control-border-color, var(--products-slider-control-border-color))',
      },
    },
  },
});

globalStyle(`${productsGrid} ${embla} .embla__viewport`, {
  paddingLeft: '0',
  paddingRight: '0',
  overflow: 'hidden',
});
/* Carousel overrides end here */

// Divider
const xAxisDivider = style({
  position: 'relative',
  selectors: {
    '&:not(:last-child)::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      width: 'var(--products-divider-thickness)',
      backgroundColor: 'var(--products-divider-color)',
      transform: 'translateX(calc(var(--gap) / 2))', // Centers the divider with the gap accounted for
    },
  },
});

const yAxisDivider = style({
  position: 'relative',
  selectors: {
    '&:not(:last-child)::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: 'var(--products-divider-thickness)',
      backgroundColor: 'var(--products-divider-color)',
      transform: 'translateY(calc(var(--gap) / 2))', // Centers the divider with the gap accounted for
    },
  },
});

export const productsGridColumn = styleVariants({
  multipleColumns: [xAxisDivider],
  singleColumn: [yAxisDivider],
});
